module.exports = __webpack_public_path__ + "img/avi.796023f3.png";